import api from './Api';

export interface IIrrfFolhaSugestaoLancamento {
    id: number;
    contaEmpresa: string;
    tipoLancamento: string; // "C" | "D"
    valor: number;
    data: string;
    historico: string | null;
}

export interface IIrrfFolhaSugestaoPendente {
    chaveVinculoMatch: string;
    lancamentos: IIrrfFolhaSugestaoLancamento[];
    justificativa: string | null;
    origemMatch: string | null;
}

export interface IIrrfFolhaConciliacaoDecisao {
    id: number;
    chaveVinculo: string;
    mesCompetencia: number;
    anoCompetencia: number;
    modalidade: string;
    statusFuncional: string;
    reasonCodes: string[];
    score: number;
    faixaScore: string;
    quantidadeProvisoes: number;
    quantidadeBaixas: number;
    /** Nulo quando o grupo fechou por soma exata (Etapas 1:1/N:1/1:N). */
    percentualDivergencia: number | null;
    /** Data do pagamento de salário usado como âncora da janela — nulo quando não veio de âncora. */
    dataAncoraSalario: string | null;
    dataCriacao: string;
}

export interface IIrrfFolhaAnaliseStatusResumo {
    status: string;
    quantidade: number;
    valor: number;
}

export interface IIrrfFolhaAuditoriaEvento {
    id: number;
    mesCompetencia: number;
    anoCompetencia: number;
    chaveVinculo: string | null;
    tipoEvento: string;
    detalhe: string;
    dataCriacao: string;
}

export interface IIrrfFolhaAnaliseConta {
    contaEmpresa: string;
    descricaoEmpresa: string | null;
    statusCartao: string;
    porcentagemConciliado: number;
    totalLancamentos: number;
    totalConciliados: number;
    totalPendentes: number;
    valorPendente: number;
    /** Código da conta de "Salários e Remunerações a Pagar" da mesma esteira, se identificada — nulo se não houver. */
    contaSalarioDetectada: string | null;
    porStatus: IIrrfFolhaAnaliseStatusResumo[];
    decisoes: IIrrfFolhaConciliacaoDecisao[];
    eventos: IIrrfFolhaAuditoriaEvento[];
}

const IrrfFolhaConciliacaoService = {
    listarSugestoesPendentes: async (esteiraId: number): Promise<IIrrfFolhaSugestaoPendente[]> => {
        const resp = await api.get(`irrf-folha-conciliacao/${esteiraId}/sugestoes`);
        return resp.data;
    },

    listarDecisoes: async (esteiraId: number): Promise<IIrrfFolhaConciliacaoDecisao[]> => {
        const resp = await api.get(`irrf-folha-conciliacao/${esteiraId}/decisoes`);
        return resp.data;
    },

    aceitarSugestao: async (esteiraId: number, chaveVinculoMatch: string): Promise<void> => {
        await api.patch(`irrf-folha-conciliacao/${esteiraId}/sugestoes/${chaveVinculoMatch}/aceitar`);
    },

    recusarSugestao: async (esteiraId: number, chaveVinculoMatch: string): Promise<void> => {
        await api.patch(`irrf-folha-conciliacao/${esteiraId}/sugestoes/${chaveVinculoMatch}/recusar`);
    },

    buscarAnalise: async (esteiraId: number): Promise<IIrrfFolhaAnaliseConta> => {
        const resp = await api.get(`irrf-folha-conciliacao/${esteiraId}/analise`);
        return resp.data;
    },
};

export default IrrfFolhaConciliacaoService;
